import * as React from "react";

export interface IDashboardPageProps {}

export const DashboardPage: React.FunctionComponent<IDashboardPageProps> = (props) => {
  return <div>DashboardPage works!</div>;
};
